import { CoreIcon } from '../core-icon';
import licensePlateSVG from '../../assets/icons/license-plate.svg';
import type { IconProps } from '../core-icon';

export const LicensePlateIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={licensePlateSVG} {...props} />;
};
